<template>
<div  style="padding-bottom:70px">
  <keep-alive>
			<router-view @change_title="change_title($event)"  @showBack="showBack"  v-if="$route.meta.keepAlive"></router-view>
	</keep-alive>

	<router-view @change_title="change_title($event)"  @showBack="showBack"  v-if="!$route.meta.keepAlive"></router-view>
 <!-- <router-view ></router-view> -->
</div>
 
</template>

<script type="text/javascript">
import Tabbar from '@/components/Tabbar.vue';
  export default {
    
    data(){
      return {
        tmapping:{},
        title:"派工",
        active:"assignWork",
        IsBack:false,
      }
    },
    name: 'RouteContent',
    
    computed: {
    // paddingBottomStyle() {
    //   // 判断当前路由是否需要 Tabbar 组件
    //   const needsTabbar = this.$route.matched.some(record => record.components.default === Tabbar);
    //   return needsTabbar ? { paddingBottom: '70px' } : {};
    // }
  },

    created(){
    let token = this.$route.query.token;
    let userId = this.$route.query.userId;
    if (typeof(token) == 'undefined' || typeof(userId) == 'undefined') {
      let sesToken = localStorage.getItem("token");
      if(!sesToken){
        return;
      }
    } else {
      // 存token
      localStorage.setItem("token",token)
      // 存userId
      localStorage.setItem("userId",userId)
    }
    },
    mounted(){

    },
    
    methods:{
      change_title (e) {
        this.title = e
      },
      showBack(){
        this.IsBack=true
      },

      back(){
        this.$router.go(-1)
        this.IsBack=false
      },
      onChange(index){
        //debugger
        this.title = this.tmapping[index];
        this.$router.push(index);
      },
      
       setFirstFlag() {
        var exdate = new Date(); //获取时间
        let key  = ""+ exdate.getFullYear()+exdate.getMonth()+exdate.getDate()+parseInt(exdate.getHours()/12)+"firstIn"
        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * 1); //保存的天数，1天
        //字符串拼接cookie
        window.document.cookie = key+"=1;path=/;SameSite=Strict;expires=" + exdate.toGMTString();
      },
      firstCheck: function() {
        var exdate = new Date(); //获取时间
        let key = ""+ exdate.getFullYear()+exdate.getMonth()+exdate.getDate()+parseInt(exdate.getHours()/12)+"firstIn"

        if (document.cookie.length > 0) {
          var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
          for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split("="); //再次切割
            //判断查找相对应的值
            if (arr2[0] == key&&arr2[1]==1) {
              return false;
            }
          }
        }
        return true;
      },
    }


  }
</script>
<style lang="scss" scoped>
 .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
  }

  .block {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #004497;
    padding: 20px;
    font-size: 48px;
    text-align: center;
  }
  .van-info--dot{
    background-color:#FA8072;
  }
  /deep/ .van-nav-bar__title{
    color:#fff!important;
    font-size: 18px;
  }
</style>